export function getCauseMessage(err: unknown): string | undefined {
  const cause = err instanceof Error ? err.cause : undefined;
  if (cause instanceof Error) {
    return cause.message;
  }
  if (cause) {
    return String(cause);
  }
  return undefined;
}
